export enum SimphonySyncMode {
  PRICE_AND_ACTIVE = 'price_and_active',
  PRICE_ONLY = 'price_only',
  ACTIVE_ONLY = 'active_only',
  FULL = 'full',
  ADD_ONLY = 'add_only',
}
